import { Injectable } from '@angular/core';

import { AuthStore } from '@store';
import { BaseApiPickerImpl } from '../base.api-picker';
import { AnalyticsApi } from './analytics.api';
import { AnalyticsMockApi } from './analytics-mock.api';

@Injectable({ providedIn: 'root' })
export class AnalyticsApiPicker extends BaseApiPickerImpl<AnalyticsApi | AnalyticsMockApi> {
  constructor(
    protected authStore: AuthStore,
    protected realApi: AnalyticsApi,
    protected mockApi: AnalyticsMockApi
  ) {
    super(authStore, realApi, mockApi);
  }
}
